/*!

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)
* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";	// reactstrap components
import * as utility from 'components/Utils';


class Local extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			connectables: []
		};

		this.getConnectables = this.getConnectables.bind(this);
	}

	componentDidMount() {
		this.getConnectables();
		// this.intervalConnectables = setInterval(() => this.getConnectables(), 60*1000);	// every 60 seconds update the battery levels
	}

	getConnectables() {
		const url = utility.getRootUrl()+'/show-connectables.php';

		fetch(url)
			.then(function (response) {
				// console.log(url + " -> " + response.ok);

				let j = null;
				try {
					j = response.json();
					return j;
				} catch (e) {
					var t = response.text();
					console.log("body not json is: " + t );
					return '{ "devices": [] }';
				}

			})
			.then(function (data) {
				// console.log("data: "); console.dir(data);

/*
{ "devices": [
{ 'url': '192.168.1.111', 'name': ' Outside Thermometer ', 'title': ' thermometer_540 ', 'hostname': '?', 'mac': '80:7d:3a:3c:30:5c' },
{ 'url': '192.168.1.177', 'name': ' Living Room Thermometer ', 'title': ' thermometer_941 ', 'hostname': '?', 'mac': '2c:3a:e8:01:20:d5' },
{ 'url': '192.168.1.120', 'name': ' Bathroom Scale Listener ', 'title': ' scale-client_924 ', 'hostname': '?', 'mac': 'b4:e6:2d:ee:61:95' },
{ 'url': '192.168.1.45', 'name': ' Furnace Controller ', 'title': ' thermostat_524 ', 'hostname': '?', 'mac': 'b4:e6:2d:ea:4b:e1' }
] }
*/
				if ( data && data.devices ) {
					this.setState({ connectables: data.devices });
				}


			}.bind(this))
		.catch(function (err) {
				console.log("failed to load ", url, err.stack);
			});
	}

	render() {
		return (
		  <>
			<div className="content">

			<h5 className="title"> Hardware </h5>

			  <Row>
				<Col md="12">
				  <Card>
					<CardHeader>
					  <h5 className="title"> Local Devices </h5>
					  <p className="category">
					  </p>
					</CardHeader>
					<CardBody>
					  <div className="typography-line">
						<div className="tat"> 
							<Row>
								<Col lg={3}> Device </Col>
								<Col lg={3}> Name </Col>
								<Col lg={3}> Mac </Col>
							</Row>
							{
								this.state.connectables.map( (dev) =>
								<Row>
									<Col lg={3}> <a href={"http://" + dev.url} rel="noopener noreferrer" target="_blank"> {dev.name} </a> </Col> 
									<Col lg={3}> {dev.title} </Col>
									<Col lg={3}> {dev.mac} </Col>
								</Row>
								)
							}
						</div>

					  </div>
					</CardBody>
				  </Card>
				</Col>
			  </Row>
			</div>
		  </>
		);
	}
}

export default Local;
